import React from "react";
import { action, observable } from "mobx";
import { observer } from "mobx-react";

import { PrincipalConfig } from "@app/AppConstants";
import { applyDecorators, EmptyProps } from "@app/Helpers/Decorator";
import { configurationStore } from "@app/Stores/ConfigurationStore";

import { emitter } from "@app/Services/EventEmitter";
import DevExtremeCssService from "@app/Services/DevExtremeCssService";

import { Icon } from "./Icon";

@observer
export default class ThemeSwitcher extends React.Component {
    //take default value from local storage related logic
    @observable public enableDarkMode: boolean = document.body.classList.contains('dark');

    constructor(props: EmptyProps) {
        super(props);
        applyDecorators(this);
    }

    async componentDidMount() {
        const darkModeQuery = configurationStore.get(PrincipalConfig.ViewGroup, PrincipalConfig.DarkMode);
        const darkMode = await darkModeQuery;

        this.switchDarkMode(!!darkMode && !!JSON.parse(darkMode), false);
        emitter.on('theme', this.onThemeUpdate);
    }

    componentWillUnmount() {
        emitter.off('theme', this.onThemeUpdate);
    }

    render() {
        let className = "user-action-icon";

        if (this.enableDarkMode) {
            className += ' dark';
        }
        return (
            <div
                title="Switch Dark \ Light theme"
                className={className}
                onClick={() => this.switchDarkMode(!this.enableDarkMode, true)}
            >
                {this.enableDarkMode ? <Icon name="moon" /> : <Icon name="sun" />}
            </div>
        );
    }

    @action.bound
    onThemeUpdate(value?: string) {
        this.enableDarkMode = value === 'dark';
    }

    @action
    public switchDarkMode(value: boolean, saveToConfig: boolean) {
        this.enableDarkMode = value;
        if (value) {
            document.body.classList.add('dark');
            document.body.setAttribute("data-bs-theme", "dark");
            localStorage.setItem('dark', 'true');
        } else {
            document.body.classList.remove('dark');
            document.body.removeAttribute("data-bs-theme");
            localStorage.removeItem('dark');
        }

        const link = document.getElementById(DevExtremeCssService.LinkId) as HTMLLinkElement;
        if (link) {
            link.href = document.body.classList.contains('dark') ? '/css/devextreme_dark.css' : '/css/devextreme.css';
        }

        emitter.emit('theme', value ? 'dark' : '');
        saveToConfig && configurationStore.set(PrincipalConfig.ViewGroup, PrincipalConfig.DarkMode, JSON.stringify(this.enableDarkMode));
    }
}